import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

export default function RequireAuth({ children }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  // Mientras Supabase está comprobando la sesión
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900">
        <p className="text-white text-lg">Cargando sesión...</p>
      </div>
    );
  }

  // Si NO hay sesión -> fuera
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Si hay sesión -> dentro
  return children;
}
